import React from 'react';
import { MdContentCopy } from 'react-icons/md';
import { toast } from 'react-toastify';

const PatientVisitInformation = ({ patient }) => {
  const copyIPToClipboard = () => {
    if (!patient?.admissionId) return;
    navigator.clipboard.writeText(patient.admissionId)
      .then(() => toast.success('IP Number copied to clipboard!'))
      .catch(() => toast.error('Failed to copy IP Number'));
  };

  return (
    <div className="panel-info-card">
      <div className="info-card-title">Ward & Billing Information</div>

      <div className="info-item-row">
        <span className="info-item-label">Room Type:</span>
        <span className="info-item-value">{patient?.roomType || 'N/A'}</span>
      </div>

      <div className="info-item-row">
        <span className="info-item-label">Bed Number:</span>
        <span className="info-item-value">{patient?.bedNumber || 'N/A'}</span>
      </div>

      <div className="info-item-row">
        <span className="info-item-label">Floor:</span>
        <span className="info-item-value">{patient?.floor || patient?.floorNumber || 'N/A'}</span>
      </div>

      <div className="info-item-row">
        <span className="info-item-label">IP Number:</span>
        <span className="info-item-value mono">
          {patient?.admissionId || 'N/A'}
          {patient?.admissionId && (
            <button
              className="copy-icon-btn"
              onClick={copyIPToClipboard}
              title="Copy IP Number"
            >
              <MdContentCopy size={13} />
            </button>
          )}
        </span>
      </div>

      <div className="info-item-row">
        <span className="info-item-label">Invoice Number:</span>
        <span className="info-item-value mono">{patient?.invoiceId || 'N/A'}</span>
      </div>

      {patient?.appointmentId && (
        <div className="info-item-row">
          <span className="info-item-label">OP Number:</span>
          <span className="info-item-value mono">{patient.appointmentId}</span>
        </div>
      )}
    </div>
  );
};

export default PatientVisitInformation;
